<template>
  <VNavigationDrawer
    v-bind="modePreset[cMode]"
    temporary
    @update:model-value="$emit('update:modelValue', $event)"
  >
    <VListItem
      :style="{ height: ($vuetify.display.mdAndUp ? '63px' : '') }"
      class="px-2"
      :title="mainTitle"
      :to="mainTo"
    >
      <template #prepend>
        <VAvatar>
          <VIcon v-if="!mainAvatarImage">
            {{ mainAvatarIcon }}
          </VIcon>
          <ImageWrapper
            v-else
            :src="mainAvatarImage"
          />
        </VAvatar>
      </template>
    </VListItem>

    <VDivider />

    <NavList :list="list" />
  </VNavigationDrawer>
</template>

<script>
import NavList from '@/components/layouts/Sidebar/NavList'
import { ImageWrapper } from '@/components/base'

import { configureCompat } from 'vue'
configureCompat({ ATTR_FALSE_VALUE: false })

export default {
  components: {
    NavList,
    ImageWrapper
  },
  props: {
    modelValue: {
      type: Boolean,
      default: true
    },
    mainTitle: {
      type: String,
      default: 'Vue Client'
    },
    mainAvatarIcon: {
      type: String,
      default: 'mdi-vuetify'
    },
    mainAvatarImage: {
      type: String,
      default: require('@/assets/images/favicon.png')
    },
    mainTo: {
      type: [String, Object],
      default: '/'
    },
    /**
     * List of item to be displayed on sidebar
     * @example
     * [
        {
          title: {String} Section title,
          divider: {Boolean} Section divider,
          debug: {Boolean} Shows only on debug,
          authenticated: {Boolean} Shows only on authenticated,
          roles: {Array} Shows only on specified roles,
          permissions: {Array} Shows only on specified permissions,
          items: {Array} [Required] Menu items
          [
            {
              title: {String} [Required] Group / Item title,
              icon: {String} Group / Item icon,
              custom: {String} Custom title in HTML string,
              debug: {Boolean} Shows only on debug,
              authenticated: {Boolean} Shows only on authenticated,
              roles: {Array} Shows only on specified roles,
              permissions: {Array} Shows only on specified permissions,
              child: {Array} Second level menu
              [
                {
                  title: {String} [Required] Child title,
                  icon: {String} Child icon,
                  custom: {String} Custom title in HTML string,
                  debug: {Boolean} Shows only on debug,
                  authenticated: {Boolean} Shows only on authenticated,
                  roles: {Array} Shows only on specified roles,
                  permissions: {Array} Shows only on specified permissions,
                  ... [@see https://vuetifyjs.com/en/api/v-list-item/#props]
                },
                ...
              ]
              ... [@see https://vuetifyjs.com/en/api/v-list-item/#props]
            },
            ...
          ]
        },
        ...
      ]
     */
    list: {
      type: Array,
      default: () => [
        {
          title: 'Examples',
          debug: true,
          items: [
            {
              title: 'Sidebar Example',
              icon: 'mdi-page-layout-sidebar-left',
              child: [
                {
                  title: 'Custom HTML',
                  icon: 'mdi-palette',
                  custom: '<span style="color: red">RED TEXT</span>'
                },
                {
                  title: 'External Link',
                  icon: 'mdi-google',
                  href: 'https://www.google.com',
                  target: '_blank'
                },
                {
                  title: 'Authenticated Only',
                  icon: 'mdi-account-check',
                  authenticated: true
                },
                {
                  title: 'Roles (A & B)',
                  icon: 'mdi-account-eye',
                  roles: ['A', 'B']
                },
                {
                  title: 'Permissions',
                  icon: 'mdi-account-key',
                  permissions: ['Permission_1', 'Permission_2']
                }
              ]
            }
          ]
        }
      ]
    }
  },
  data () {
    return {
      modePreset : {
        mobileHidden: {
          modelValue: false,
        },
        mobileShow:  {
          modelValue: true
        },
        show:  {
          modelValue: true,
          permanent: true
        },
        mini:  {
          modelValue: true,
          permanent: true,
          rail: true,
          expandOnHover: true,
        },
      }
    }
  },
  computed: {
    cMode () {
      if (this.$vuetify.display.mobile) {
        return this.modelValue ? 'mobileShow' : 'mobileHidden'
      }
      else {
        return this.modelValue ? 'show' : 'mini'
      }
    }
  }
}
</script>
